import axios, { AxiosResponse } from "axios";
import { ServerSettings } from "../models/serverSettings";

export const getServerSettings = async (): Promise<AxiosResponse<ServerSettings>> => {
    return await axios.get("/dispatcher/user/serverSettings");
};
